import Mitt from "mitt";

export const notificationBus = Mitt();

export const NOTIFICATION_EVENTS = {
  TRIGGER: "TRIGGER",
};
